(() => {
  const enhance = (root = document) => {
    root.querySelectorAll('variant-selects').forEach(picker => {
      if (picker.dataset.rossityPictures === 'true') return;
      const groups = Array.from(picker.querySelectorAll('.product-form__input'));
      if (groups.length !== 2) return;
      const data = picker.querySelector('script[type="application/json"]');
      if (!data) return;
      let variants;
      try { variants = JSON.parse(data.textContent); } catch { return; }
      if (!variants.some(v => ['Monster', 'Red Bull', 'Celsius'].includes(v.option1))) return;
      picker.dataset.rossityPictures = 'true';
      const refresh = () => {
        const family = groups[0].querySelector('input:checked')?.value;
        groups[1].querySelectorAll('input[type="radio"]').forEach(input => {
          const label = input.nextElementSibling;
          if (!label || label.tagName !== 'LABEL') return;
          const variant = variants.find(v => v.option1 === family && v.option2 === input.value);
          if (!variant) return;
          const imageData = variant.featured_image || variant.featured_media?.preview_image;
          if (!imageData?.src) return;
          let img = label.querySelector('img');
          if (!img) {
            img = document.createElement('img');
            img.className = 'variant-pill__swatch variant-pill__swatch--image';
            img.width = 80;
            img.height = 100;
            img.loading = 'lazy';
            label.prepend(img);
          }
          const url = new URL(imageData.src, location.origin);
          url.searchParams.set('width', '200');
          img.src = url.href;
          img.alt = family + ' ' + input.value + ' can plush';
        });
      };
      picker.addEventListener('change', refresh);
      refresh();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
